import React from "react";
import PropTypes from "prop-types";
import styles from "./TrendingSection.module.css";
import { TrendingBarChart } from "../TrendingBarChart";

export function TrendingSection({
  speakersData,
  contentData,
  speakersTimeframe,
  contentTimeframe,
  onSpeakersTimeframeChange,
  onContentTimeframeChange,
}) {
  const speakersChartData = React.useMemo(
    () => speakersData.map((d) => ({ label: d.name, value: d.listens })),
    [speakersData],
  );

  const contentChartData = React.useMemo(
    () => contentData.map((d) => ({ label: d.title, value: d.listens })),
    [contentData],
  );

  const speakersSummary = React.useMemo(
    () => speakersData.reduce((sum, d) => sum + d.listens, 0).toLocaleString(),
    [speakersData],
  );

  const contentSummary = React.useMemo(
    () => contentData.reduce((sum, d) => sum + d.listens, 0).toLocaleString(),
    [contentData],
  );

  return (
    <div className={styles.section}>
      <div className={styles.sectionHeader}>
        <span className={styles.headerLine} />
        <h2 className={styles.headerTitle}>Trending</h2>
        <span className={styles.headerLine} />
      </div>

      <div className={styles.chartsRow}>
        <TrendingBarChart
          title="Speakers"
          data={speakersChartData}
          timeframe={speakersTimeframe}
          summaryValue={speakersSummary}
          onTimeframeChange={onSpeakersTimeframeChange}
        />
        <TrendingBarChart
          title="Content"
          data={contentChartData}
          timeframe={contentTimeframe}
          summaryValue={contentSummary}
          onTimeframeChange={onContentTimeframeChange}
        />
      </div>
    </div>
  );
}

const speakerShape = PropTypes.shape({
  name: PropTypes.string.isRequired,
  listens: PropTypes.number.isRequired,
});

const contentShape = PropTypes.shape({
  title: PropTypes.string.isRequired,
  listens: PropTypes.number.isRequired,
});

const TIMEFRAME_OPTIONS = ["This Week", "This Month", "This Year"];

TrendingSection.propTypes = {
  speakersData: PropTypes.arrayOf(speakerShape).isRequired,
  contentData: PropTypes.arrayOf(contentShape).isRequired,
  speakersTimeframe: PropTypes.oneOf(TIMEFRAME_OPTIONS).isRequired,
  contentTimeframe: PropTypes.oneOf(TIMEFRAME_OPTIONS).isRequired,
  onSpeakersTimeframeChange: PropTypes.func.isRequired,
  onContentTimeframeChange: PropTypes.func.isRequired,
};
